import React, { useEffect, useState } from "react";
import projectsApi from "../Home/HomeApi.json";
import Projects from "./Projects";

const ProjectsData = () => {
  const [pro, setPro] = useState([]);

  useEffect(() => {
    setPro(projectsApi);
    console.log(setPro);
  }, []);
  // const projectTechnology = [
  //   {
  //     javascript:
  //       "https://user-images.githubusercontent.com/67714964/112378990-d0161280-8d11-11eb-8fcb-b0ae2a7ae7d7.png",
  //   },
  //   {
  //     reactjs:
  //       "https://user-images.githubusercontent.com/67714964/112376855-2d5c9480-8d0f-11eb-9621-f93655564a59.png",
  //   },
  //   {
  //     nodejs:
  //       "https://user-images.githubusercontent.com/67714964/112377438-f0dd6880-8d0f-11eb-84e4-e40e7caaebf4.png",
  //   },
  //   {
  //     express:
  //       "https://user-images.githubusercontent.com/67714964/112380462-9b0abf80-8d13-11eb-982a-639732b42e88.png",
  //   },
  //   {
  //     mongodb:
  //       "https://user-images.githubusercontent.com/67714964/112377514-0d79a080-8d10-11eb-807c-e5abab817824.jpg",
  //   },
  //   {
  //     html:
  //       "https://user-images.githubusercontent.com/67714964/112381905-597b1400-8d15-11eb-9915-f92f28ea8887.png",
  //   },
  //   {
  //     css:
  //       "https://user-images.githubusercontent.com/67714964/112382022-83ccd180-8d15-11eb-99f6-270f8248477d.png",
  //   },
  //   {
  //     bootstrap:
  //       "https://user-images.githubusercontent.com/67714964/112378375-0bfca800-8d11-11eb-9662-0326d7cf53ff.png",
  //   },
  //   {
  //     material:
  //       "https://user-images.githubusercontent.com/67714964/112380958-37cd5d00-8d14-11eb-8804-4775387cc90f.png",
  //   },
  //   {
  //     illustrator:
  //       "https://user-images.githubusercontent.com/67714964/112382533-2c7b3100-8d16-11eb-96f9-21ef327613c0.png",
  //   },
  //   {
  //     photoshop:
  //       "https://user-images.githubusercontent.com/67714964/112382943-b0cdb400-8d16-11eb-88ab-a8317c6c0553.png",
  //   },
  //   {
  //     xd:
  //       "https://user-images.githubusercontent.com/67714964/112383006-c5aa4780-8d16-11eb-9798-88d64bbd29bc.png",
  //   },
  // ];
  return (
    <div>
      {/* {projectTechnology.map((projectTech) => (
        <Projects projectTech={projectTech} />
      ))} */}

      {pro.map((project) => (
        <Projects project={project} />
      ))}
    </div>
  );
};

export default ProjectsData;
